/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React from 'react';
import { Chrono } from 'react-chrono';
import { useViewport } from '@vlinder-web/viewport-provider-react';
import './styles.css';

export interface ITimelineProps {
  items?: any[];
}

export const TimelineComp = (props: ITimelineProps) => {
  const { items } = props;
  const { bp } = useViewport();

  //   if (items && Array.isArray(items) && items.length === 0) return null;
  return (
    <Chrono
      items={items}
      {...props}
      mode={bp === 'xs' ? 'VERTICAL' : 'VERTICAL_ALTERNATING'}
      enableOutline={true}
      theme={{
        secondary: '#56DCBA',
        primary: '#1F2937',
        // cardBgColor: "red",
        // cardForeColor: "violet",
        // titleColor: "#068a55",
        titleColorActive: '#000000',
      }}
      hideControls={true}
    />
  );
};

TimelineComp.defaultProps = {};
